export default "__VITE_ASSET__ClPk5Dsp__"